import QSwitch from './src/component';



export default QSwitch;

